import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { atom } from 'jotai';
import { ExperienceRelatedArticle } from 'shared/models';
import { Unreachable } from '@lemon8/web-app-shared/util';

type TExperienceRelatedPostStore = {
  [key: string]: Promise<ExperienceRelatedArticle> | ExperienceRelatedArticle | undefined;
};

const $ExperienceRelatedPostStore = atom<TExperienceRelatedPostStore>({});

export const $ExperienceRelatedPost = safeAtomFamily((keyword: string) => {
  const a = atom(
    (get) => {
      const data = get($ExperienceRelatedPostStore)[keyword];
      if (!data) {
        return Unreachable(`no data for keyword: ${keyword}`);
      }
      return data;
    },
    (get, set, input: ExperienceRelatedArticle | Promise<ExperienceRelatedArticle>) => {
      const old = get($ExperienceRelatedPostStore);
      set($ExperienceRelatedPostStore, {
        ...old,
        [keyword]: input,
      });
    },
  );

  a.debugLabel = `$ExperienceRelatedPost+${encodeURIComponent(keyword)}`;

  return a;
});
